var chunkToChildrenMap = {
	"2568": [
		1169
	],
	"2791": [
		3658
	],
	"6591": [
		2412
	],
	"6609": [
		8315
	],
	"7360": [
		8714
	],
	"8605": [
		8714,
		1498
	],
	"8829": [
		1169,
		2898
	],
	"8944": [
		3286
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));